import CreditOperatorFormConfig from "./form";
import { CreditOperatorApi, CreditOperatorDataType } from "@/api/CreditOperatorApi";
import { CreditOperatorFormData } from "@/formTypes/CreditOperatorFormDataType";
import GenericForm from "../GenericForm";

type CreditOperatorFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const CreditOperatorForm = (props: CreditOperatorFormProps) => {

  return (
    <GenericForm<CreditOperatorFormData, CreditOperatorDataType>
      id={props.id}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={CreditOperatorFormConfig}
      getById={(...arg) => CreditOperatorApi.get(...arg)}
      createFn={(...arg) => CreditOperatorApi.create(...arg)}
      updateFn={(...arg) => CreditOperatorApi.update(...arg)}
      successMessage="El Operador de Tarjeta ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información del Operador de Tarjeta"
    />
  )
}

export default CreditOperatorForm;